Vue.component('ErrorPageIndexComponent', require('./components/ErrorPageIndexComponent').default);
Vue.component('ErrorPageGetComponent', require('./components/ErrorPageFormComponent').default);
